import { type DeliveriesState } from "./state";

export const initialState: DeliveriesState = {
  deliveries: [],
  isPending: false,
  isRejected: false,
  errorMessage: "",
};
